import { createSlice } from "@reduxjs/toolkit";

const transactionSlice = createSlice({
  name: 'transaction',
  initialState: { value: '' },
  reducers: {
    updateTransaction: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const { updateTransaction } = transactionSlice.actions;
export default transactionSlice.reducer;
